import ProcessFlowStep from "~/models/processFlows/processFlowStep";
import {ProcessFlowStepType} from "../../../enums/processFlowStepType";
import ProcessFlow from "~/models/processFlows/processFlow";
import {Hash} from "~/interfaces/hashInterfaces";
import {IIterationStep, IProcessFlowMappedVariable, IProcessFlowStep, IProcessFlowVariable} from "~/interfaces/processFlowInterfaces"
import {IHasParent, ITrackedModel} from "~/interfaces/modelInterfaces";
import ProcessFlowStepFactory from '~/models/processFlows/processFlowStepFactory'
import {IterationStepVariableMap} from '~/models/processFlows/steps/iterationStepVariableMap'
import {IClientIdable} from '~/interfaces/propertyInterfaces'
import {IReferencePathServiceType} from '~/interfaces/referencePathInterfaces'
import ProcessFlowVariable from '~/models/processFlows/processFlowVariable'
import ProcessFlowStepContainer from "~/mixins/processFlowStepContainer"

export default class IterationStep extends ProcessFlowStepContainer(ProcessFlowStep) implements IIterationStep {
  step_type: ProcessFlowStepType.RunIteration;
  variable_map: IterationStepVariableMap

  constructor(parent: ProcessFlow | IterationStep, options) {
    super(parent, options);
  }

  // ******************** RELATIONS AND REPOS ******************** //
  // @see ProcessFlowStepDefinition.createEmbeddedDefinitionFactory
  declare createEmbeddedObject: {
    variable_map: (parent, json: Hash & Partial<IClientIdable>) => IterationStepVariableMap
  }

  initializeEmbedded(parent: IterationStep & ITrackedModel, item: IProcessFlowStep & IHasParent<IterationStep>) {
    item.triggerChanges = true
    item.parent = parent
    item.startTracking()
    this.placeInDictionary(item, item.rootName, this)
    parent.trackCreationDeletion(item.client_id, null, item.asJson(), item);
    return item;
  }

  createStep(parent, json) {
    return ProcessFlowStepFactory.findOrCreate([json.client_id, json.id], parent, json.step_type)
  }

  createVariableMap(parent = this, json = {}): IterationStepVariableMap {
    const varMap = this.createEmbeddedObject.variable_map(parent, json)
    varMap.attachToParent(parent)
    return varMap
  }

  // ******************** RELATIONS AND REPOS END ******************** //

  /**
   * Right now the title for display on IterationStep is calculated in the view
   */
  get defaultTitle(): string {
    return `Iterate through ${this.collectionNodeService?.label} as ${this.iterationVariable?.nameOrDefault}`
  }

  get variableMap(): IterationStepVariableMap {
    return this.variable_map || this.createVariableMap()
  }

  get variableReference(): IProcessFlowMappedVariable {
    return this.variableMap.variableReference
  }

  /**
   * For common process flow step interface
   */
  get destinationVariable(): IProcessFlowVariable {
    return this.iterationVariable
  }

  get destinationVariableClientId(): string {
    return this.variableReference.destination_variable_client_id
  }

  set destinationVariableClientId(val: string) {
    this.variableReference.destination_variable_client_id = val
  }
  //*****

  private get collectionNodeService(): IReferencePathServiceType | null {
    return this.variableReference.source_variable_path?.lastNodeService
  }

  /**
   * The variable that each item in the collection is assigned to
   * @private
   */
  private get iterationVariable(): IProcessFlowVariable {
    return ProcessFlowVariable.repo.find(this.destinationVariableClientId)
  }

  get canContainFinalStep(): boolean {
    return false
  }
}